import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { saveVariableGlo } from "../actions/chariotActions";
import { listeClients, logout } from "../actions/clientsActions";
import { listeSocietes } from "../actions/societeActions";
import { messagesListe } from "../actions/messageActions";
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBell,
  faLayerGroup,
  faObjectGroup,
  faUserGear,
  faMessage,
  faNetworkWired,
} from "@fortawesome/free-solid-svg-icons";
import { IoHomeOutline, IoBriefcaseOutline } from "react-icons/io5";
import "../DemCliFinale.css";

const DemCliFinal = () => {
  const Cl = useSelector((state) => state.client);
  const { client } = Cl;
  const mliste = useSelector((state) => state.msg_distant);
  const { msg } = mliste;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { langue } = location.state || {};

  const listeSoc = useSelector((state) => state.listeSocietes);
  const { societes } = listeSoc;

  const totmsg = () => {
    let n = 0;
    msg?.forEach((m) => {
      m?.tokens?.forEach((t) => {
        if (t.value === client.nom_cli) n++;
      });
    });
    return n;
  };

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      const message = "Voulez-vous vraiment quitter?";
      e.returnValue = message;
      return message;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    dispatch(saveVariableGlo(client));

    if (!client) {
      navigate("/");
    } else {
      localStorage.setItem("persist", client?.persist ? "true" : "false");
      dispatch(messagesListe());
    }
  }, [dispatch, client, navigate]);

  const deconnexionHandler = () => {
    dispatch(logout());
    navigate("/");
  };

  return (
    <div className="container-f">
      <div className="background-image-f">
        <div className="header-f">
          <h1 className="company-name-f">{societes[0]?.nom_soc}</h1>
          <h2 className="app-title-f">منصة الطلبيات</h2>
        </div>

        {langue === "A" ? (
          <div className="buttons-container-arabic">
            <button
              className="action-button-arabic"
              onClick={() =>
                navigate("/main/marque-liste", { state: { langue } })
              }
            >
              <FontAwesomeIcon icon={faLayerGroup} size="2x" color="#C70039" />
              <span>قــــائـــمة مــــاركــات البـضاعـــة</span>
            </button>

            <button
              className="action-button-arabic"
              onClick={() =>
                client.specialise === "N"
                  ? navigate("/main/famille-liste", { state: { langue } })
                  : navigate("/main/tous-articles", { state: { langue } })
              }
            >
              <FontAwesomeIcon icon={faObjectGroup} size="2x" color="#C70039" />
              <span>قــــائـــمة عــائلات البـــــضاعـــة</span>
            </button>

            <button
              className="action-button-arabic"
              onClick={() => navigate("/liste-commandes")}
            >
              <FontAwesomeIcon
                icon={faUserGear}
                size="2x"
                color="#C70039"
                bounce
              />
              <span>قـــــــائـــــــــمة الطلبيـــات</span>
            </button>

            <button
              className="action-button-arabic"
              onClick={() =>
                navigate("/liste-messages", {
                  state: { langue, societe: societes[0] },
                })
              }
            >
              <FontAwesomeIcon icon={faMessage} size="2x" color="#C70039" />
              <span>مراسلة</span>
            </button>
          </div>
        ) : (
          <div className="buttons-container-f">
            <button
              className="action-button-f"
              onClick={() =>
                client?.specialise === "N"
                  ? navigate("/ListeFamille", { state: { langue } })
                  : navigate("/ToutArticles", { state: { langue } })
              }
            >
              <IoHomeOutline size={50} color="#C70039" />
              <span>
                {client?.specialise === "N"
                  ? "Famille article"
                  : "Choisir article"}
              </span>
            </button>

            <button
              className="action-button-f"
              onClick={() =>
                navigate("/RepresDetail", {
                  state: { code: client.cod_cli },
                })
              }
            >
              <FontAwesomeIcon
                icon={faUserGear}
                size="2x"
                color="#C70039"
                bounce
              />
              <span>Mes Commandes</span>
            </button>

            <button
              className="action-button-f"
              onClick={() =>
                navigate("/liste-messages", {
                  state: { langue, societe: societes[0] },
                })
              }
            >
              <FontAwesomeIcon icon={faMessage} size="2x" color="#C70039" />
              <span>Envoie reclamation</span>
            </button>

            <button
              className="action-button-f"
              onClick={() => deconnexionHandler()}
            >
              <FontAwesomeIcon
                icon={faNetworkWired}
                size="2x"
                color="#C70039"
              />
              <span>Déconnexion</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default DemCliFinal;
